import { render, staticRenderFns } from "./extensionSearchForm.vue?vue&type=template&id=a2c8c5e8&scoped=true"
import script from "./extensionSearchForm.vue?vue&type=script&lang=js"
export * from "./extensionSearchForm.vue?vue&type=script&lang=js"
import style0 from "./extensionSearchForm.vue?vue&type=style&index=0&id=a2c8c5e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2c8c5e8",
  null
  
)

export default component.exports